export default __webpack_public_path__ + "static/media/noImage.5f09172c.png";